import { useContext } from "react";
import { SetupContext } from "../context/SetupContext";

export const useSetup = () => useContext(SetupContext);
